import { css } from "styled-components";
import { dominant, form, transparentize } from "@glossy";

export const SIZES = {
  xs: { height: 24, padding: 12, radius: 4 },
  s: { height: 32, padding: 12, radius: 4 },
  m: { height: 36, padding: 16, radius: 6 },
  l: { height: 48, padding: 16, radius: 8 },
};
export type Size = keyof typeof SIZES;

export const VARIANTS = {
  primary: css`
    background-color: ${(props) =>
      transparentize(0.85, form(props, "primary"))};
    :hover {
      background-color: ${(props) =>
        transparentize(0.8, form(props, "primary"))};
    }
    :focus {
      box-shadow: 0 0 0 2px ${dominant} inset;
      background-color: transparent;
    }
  `,
  secondary: css`
    background-color: transparent;
    box-shadow: 0 0 0 1px
      ${(props) => transparentize(0.5, form(props, "primary"))} inset;
    :hover {
      box-shadow: 0 0 0 1px ${form} inset;
    }
    :focus {
      box-shadow: 0 0 0 2px ${dominant} inset;
    }
  `,
  tertiary: css`
    border-radius: 0;
    background-color: transparent;
    box-shadow: 0 -1px 0 0 ${(props) =>
        transparentize(0.5, form(props, "primary"))} inset;
    :hover {
      box-shadow: 0 -1px 0 0 ${form} inset;
    }
    :focus {
      box-shadow: 0 -2px 0 0 ${dominant} inset;
    }
  `,
} as const;
export type Variant = keyof typeof VARIANTS;

const attr = (key: string) => ({ $size }: { $size: Size }): string =>
  SIZES[$size][key];
export const height = attr("height");
export const padding = attr("padding");
export const radius = attr("radius");
